import request from '@/utils/request'
import axios from 'axios'

export const financialApi = {
  // 新增/编辑财务记录
  edit(data) {
    return request({
      url: '/inventory-management-api/financial/edit',
      method: 'POST',
      data
    })
  },

  // 查询财务记录列表
  list(data) {
    return request({
      url: '/inventory-management-api/financial/list',
      method: 'POST',
      data
    })
  },

  // 查询财务记录详情
  detail(id) {
    return request({
      url: '/inventory-management-api/financial/detail',
      method: 'POST',
      data: {
        id: id
      }
    })
  },

  // 查询财务记录汇总统计
  getSummary(data) {
    return request({
      url: '/inventory-management-api/financial/sumRes',
      method: 'POST',
      data
    })
  },

  // 获取财务记录多维度汇总统计
  summary(data) {
    return request({
      url: '/inventory-management-api/financial/summary',
      method: 'POST',
      data
    })
  },

  // 导出财务记录Excel
  export(data) {
    const sessionId = localStorage.getItem('sessionId') || ''
    const requestData = {
      sessionId: sessionId,
      data: data || {}
    }

    return axios({
      url: '/inventory-management-api/financial/export',
      method: 'POST',
      data: requestData,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
      baseURL: process.env.NODE_ENV === 'development' ? '' : (process.env.VUE_APP_API_BASE_URL || ''),
      timeout: 30000
    })
  },

  // 删除财务记录
  delete(data) {
    return request({
      url: '/inventory-management-api/financial/delete',
      method: 'POST',
      data
    })
  },

  // 导出财务汇总Excel
  exportSummary(data) {
    const sessionId = localStorage.getItem('sessionId') || ''
    const requestData = {
      sessionId: sessionId,
      data: data || {}
    }

    return axios({
      url: '/inventory-management-api/financial/summary/export',
      method: 'POST',
      data: requestData,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
      baseURL: process.env.NODE_ENV === 'development' ? '' : (process.env.VUE_APP_API_BASE_URL || ''),
      timeout: 30000
    })
  }
}